import React from 'react';
import { NestedTable } from '../../NestedTable';

import { getMembers } from '../../NestedTable/utils';
import { SectionContainer } from '../../../SectionContainer';
import { SectionSubtitles } from '../SectionSubtitles';
import { hasMembers } from '../utils';
import { StoreContext } from '../../../../appContext/StoreProvider';
import { Text } from '../../../PageElements/Text';

export const RPCResponseTable = ({ response, prefix, pageName }) => {
  const { store } = React.useContext(StoreContext);

  /**
   * Currently, we support only one return type in RPC response tables.
   */
  const returnObjectType = Array.isArray(response.type)
    ? response.type[0]
    : response.type;
  const returnObject = getMembers(store)(returnObjectType);

  return (
    <SectionContainer title="Response">
      <SectionSubtitles
        subtitle={response.doc}
        prefix={prefix}
        pageName={pageName}
      />
      {hasMembers(returnObject) ? (
        <NestedTable
          tableDepth={0}
          params={returnObject.members}
          isResponse={true}
        />
      ) : (
        <Text dataHook="rpc-response-empty-state">
          Returns an empty object.
        </Text>
      )}
    </SectionContainer>
  );
};
